/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LeaseInfo {

    /**
     * 契約台数
     */
    ctrNumberofunits?: string;
    /**
     * 解約台数
     */
    breakNumberofunits?: string;
    /**
     * リース計算指示コード
     */
    leaseCalculationsijiCode?: string;
    /**
     * リース機器有効期限年月
     */
    leaseDeviceExpirationyearandmonth?: string;
    /**
     * リース契約終了年月日
     */
    leaseCtrendYearmonthdate?: string;
    /**
     * 有効期限月数
     */
    expirationdateNumberofmonths?: string;
}

